import { combineReducers } from '@reduxjs/toolkit';

import cardInfoReducer from './cardInfo';
import check3dsReducer from './check3ds';
import detailsLinkReducer from './detailsLink';
import configReducer from './getConfig';
import innReducer from './inn';
import operationsReducer from './operations';
import passportRecognitionReducer from './passportRecognition';
import paymentCheckReducer from './paymentCheck';
import pinCodeReducer from './pinCode';
import cardRefillReducer from './refillCard';
import refillLinkReducer from './refillLink';
import cardReleaseReducer from './releaseCard';
import settings from './settings';
import transferLinkReducer from './transferLink';
import cardUpgradeReducer from './upgradeCard';
import verificationCodeReducer from './verificationCode';

export default combineReducers({
  cardInfo: cardInfoReducer,
  cardRefill: cardRefillReducer,
  cardRelease: cardReleaseReducer,
  cardUpgrade: cardUpgradeReducer,
  check3ds: check3dsReducer,
  config: configReducer,
  detailsLink: detailsLinkReducer,
  inn: innReducer,
  operations: operationsReducer,
  passportRecognition: passportRecognitionReducer,
  paymentCheck: paymentCheckReducer,
  pinCode: pinCodeReducer,
  refillLink: refillLinkReducer,
  transferLink: transferLinkReducer,
  verificationCode: verificationCodeReducer,
  settings,
});
